// const baseurl = process.env.NODE_ENV === 'production'
//   ? 'https://sahilsapariya.pythonanywhere.com'
//   : 'http://127.0.0.1:8000';

const baseurl = "https://sahilsapariya.pythonanywhere.com"
// const baseurl = "http://127.0.0.1:8000";
export default baseurl;